import { useMemo } from 'react';
import { AttachLink, GroupModel, PostModel, UserModel } from '$store/models';
import { ModalLink } from '$shared/components';
import { useTranslator } from '$hooks/useTranslator';
import { useCurrentLang } from '$hooks/useCurrentLang';
import { transliterate } from '$utils';

export function useLinkData(link?: AttachLink) {
  const t = useTranslator();
  const currentLang = useCurrentLang();
  const isRU = currentLang.key === 'ru';

  return useMemo(() => {
    let title = '';
    let description = '';
    let image = '';
    let type = t('attach_type_link');
    let buttonText = t('attach_type_link_button_text');
    let linkComponent: any = 'a';
    let linksOptions: any = {
      href: '',
      target: '_blank',
    };

    if (link)
      switch (link.type) {
        case 'post': {
          const post = link.object as PostModel;
          title = '';
          description = post.text || t('attach_type_post_description');
          type = t('attach_type_post');
          buttonText = t('attach_type_post_button_text');
          linkComponent = ModalLink;
          linksOptions = {
            name: `post${post.id}`,
          };

          if (post.ownerId > 0) {
            const user = link.extra as UserModel;
            const fullName = `${user.firstName} ${user.lastName}`;
            title = isRU ? fullName : transliterate(fullName);
            image = user.photo;
          } else {
            const group = link.extra as GroupModel;
            title = isRU ? group.name : transliterate(group.name);
            image = group.photo;
          }
          break;
        }

        case 'external_video': {
          title = link.object.title;
          description = link.object.description;
          image = link.object.imageUrl;
          buttonText = t('attach_type_external_video_button_text');
          linksOptions.href = link.object.url;

          if (link.object.platfrom === 'youtube') {
            type = t('attach_type_external_video_youtube');
          } else if (link.object.platfrom === 'tiktok') {
            type = t('attach_type_external_video_tiktok');
          } else {
            type = t('attach_type_external_video');
          }
          break;
        }

        case 'nft': {
          title = link.object.title;
          description = link.object.description;
          image = link.object.imageUrl;
          linksOptions.href = link.object.url;
          type = 'NFT';
          break;
        }

        case 'battle': {
          title = link.object.title;
          description = link.object.description;
          image = link.object.imageUrl;
          linksOptions.href = `https://ton.place/battle/${link.object.id}`;
          break;
        }

        case 'app': {
          title = link.object.name;
          description = link.object.description;
          image = link.object.photo;
          linksOptions.href = `https://ton.place/app/${link.object.id}`;
          type = 'Application';
          break;
        }
      }

    return {
      title,
      description,
      image,
      type,
      buttonText,
      linkComponent,
      linksOptions,
    };
  }, [link, t]);
}
